export interface PartnersLogo {
  name: string;
  path: string;
}

export const partnersLogos: PartnersLogo[] = [
  {
    name: "Auckland University",
    path: "au.png",
  },
  {
    name: "Aurecon",
    path: "aurecon.jpg",
  },
  {
    name: "NHC",
    path: "nhc-logo.svg",
  },
  {
    name: "Geoscience Australia",
    path: "ga.jpg",
  },
  {
    name: "GEM",
    path: "gem.png",
  },
  {
    name: "GFZ",
    path: "gfz.png",
  },
  {
    name: "IU",
    path: "iu.png",
  },
  {
    name: "Lamont",
    path: "lamont.jpg",
  },
  {
    name: "MBIE",
    path: "mbie.png",
  },
  {
    name: "MissouriS&T",
    path: "missouriST.png",
  },
  {
    name: "NIWA",
    path: "niwa.jpg",
  },
  {
    name: "SCEC",
    path: "scec.png",
  },
  {
    name: "UCLA",
    path: "ucla.jpg",
  },
  {
    name: "ucRed",
    path: "ucRed.jpg",
  },
  {
    name: "University of Otago",
    path: "uoo.png",
  },
  {
    name: "USC",
    path: "usc.png",
  },
  {
    name: "USGS",
    path: "usgs.png",
  },
  {
    name: "VUW",
    path: "vuw.png",
  },
  {
    name: "WSP",
    path: "wsp.jpg",
  },
];
